import type { ReactNode, HTMLAttributes } from "react";

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
  padding?: "none" | "sm" | "md" | "lg";
  hover?: boolean;
}

export default function Card({
  children,
  padding = "md",
  hover = false,
  className = "",
  ...props
}: CardProps) {
  const paddings: Record<string, string> = {
    none: "",
    sm: "p-3",
    md: "p-4 md:p-5",
    lg: "p-6 md:p-8",
  };

  return (
    <div
      className={`bg-white border border-background-200/70 rounded-lg ${paddings[padding]} ${
        hover
          ? "cursor-pointer transition-all duration-150 hover:border-primary-200 hover:bg-primary-50/30"
          : ""
      } ${className}`}
      {...props}
    >
      {children}
    </div>
  );
}